import { useEffect, useState, Fragment, useRef } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import Select from "react-select";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { ListDateType } from "helper/constant";
import { getReturnOrders, getReturnRecordsById, exportReturnOrders } from "actions/returnOrderActions";
import { getStaffs } from "actions/teamActions";
import { ReactTable } from "components/Table";
import { formatterCreateAt, convertTZ, subStringText, FormatterMoney } from "components/Function";
import SelectBox from "components/elements/selectBox";
import Loading from "components/Loading";
import ReactImageMagnify from 'react-image-magnify';
import cx from "classnames";
import ModalRecord from "./modaRecord";
import { CSVLink } from "react-csv";

const Returns = ({ getReturnOrders, returnOrders, formatterCreateAt, getStaffs, subStringText, getReturnRecordsById, exportReturnOrders }) => {
    const [page, setPage] = useState(1);
    const [sizePerPage, setSizePerPage] = useState(50);
    const [searchText, setSearchText] = useState("");
    const [totalSize, setTotalSize] = useState(0);
    const [dateType, setDateType] = useState("");
    const [filter, setFilter] = useState({});
    const [staffs, setStaffs] = useState([]);
    const [shops, setShops] = useState([]);
    const [records, setRecords] = useState([]);
    const [openIndex, setOpenIndex] = useState(null);
    const [forceRender, setForceRender] = useState(false);
    const [export_return_orders_data, setExportReturnOrdersData] = useState([]);
    const [initiateDownload, setInitiateDownload] = useState(false);
    const btnRef = useRef(null);

    const { t } = useTranslation();
    const { list, totalsize, isLoading, list_shop, total_revenue, all_return_orders_for_export } = returnOrders;

    const listshop = list_shop?.map((v, i) => {
        return { "label": `${v?.name} (${v?.note}) - ${v?.region}`, "value": v?._id };
    })

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
        setForceRender((prev) => !prev);
    };


    const listStatus = [
        { "label": "IN_PROGRESS", "value": "IN_PROGRESS" },
        { "label": "SUPPORT_BUYER", "value": "SUPPORT_BUYER" },
        { "label": "SUPPORT_SELLER", "value": "SUPPORT_SELLER" },
        { "label": "CLOSED", "value": "CLOSED" },
    ]

    const listReturnType = [
        { "label": "RETURN_AND_REFUND", "value": "RETURN_AND_REFUND" },
        { "label": "REFUND", "value": "REFUND" },
        { "label": "REPLACEMENT", "value": "REPLACEMENT" },
    ]

    const sizePerPageList = [
        {
            text: "10",
            value: 10,
        },
        {
            text: "50",
            value: 50,
        },
        {
            text: "100",
            value: 100,
        },
        {
            text: "150",
            value: 150,
        },
        {
            text: "200",
            value: 200,
        },
        {
            text: "All",
            value: totalsize || 50,
        },
    ];

    useEffect(() => {
        if (Object.keys(filter).length) {
            getReturnOrders({ page, sizeperpage: sizePerPage, search: searchText, filter });
        }
    }, [getReturnOrders, page, sizePerPage, searchText, filter]);

    useEffect(() => {
        setTotalSize(totalsize);
    }, [totalsize]);

    useEffect(() => {
        getStaffs({ sizeperpage: 100 }).then((data) => {
            setStaffs(data?.data?.map((staff) => ({ value: staff?.user?._id, label: staff.user.email + " - " + staff?.user?.name })) || []);
        });
    }, [getStaffs]);

    useEffect(() => {
        setPage(1);
        setSizePerPage(50);

        if (dateType === "") {
            setFilter((prev) => ({
                ...prev,
                dateStart: "",
                dateEnd: "",
            }));
        }
        if (dateType === "custom") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "today") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date();
            date_end = convertTZ(date_end);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "yesterday") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate());
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_week") {
            let date_start = new Date();
            date_start = convertTZ(date_start);
            date_start.setDate(date_start.getDate() - 7 - date_start.getDay() + 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date_start);
            date_end.setDate(date_end.getDate() + 6);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_month") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_month") {
            let date = new Date();
            date = convertTZ(date);
            date.setMonth(date.getMonth() - 1);
            let date_start = new Date(date.getFullYear(), date.getMonth(), 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), date.getMonth() + 1, 0);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "this_year") {
            let date = new Date();
            date = convertTZ(date);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        if (dateType === "last_year") {
            let date = new Date();
            date = convertTZ(date);
            date.setFullYear(date.getFullYear() - 1);
            let date_start = new Date(date.getFullYear(), 0, 1);
            date_start.setHours(0, 0, 0, 0);

            let date_end = new Date(date.getFullYear(), 11, 31);
            date_end.setHours(23, 59, 59, 999);
            setFilter((prev) => ({
                ...prev,
                dateStart: date_start.getTime(),
                dateEnd: date_end.getTime(),
            }));
        }
        // eslint-disable-next-line
    }, [dateType]);

    useEffect(() => {
        if (all_return_orders_for_export && all_return_orders_for_export.length > 0) {
            var export_return_orders_data = [];
            for (var i = 0; i < all_return_orders_for_export.length; i++) {
                for (var j = 0; j < all_return_orders_for_export[i]?.return_line_items.length; j++) {
                    var export_return_orders_data_tmp = {
                        return_id: j === 0 ? "'" + all_return_orders_for_export[i]?.return_id : "",
                        order_id: j === 0 ? "'" + all_return_orders_for_export[i]?.apiOrderId : "",
                        can_buyer_keep_item: j === 0 ? (all_return_orders_for_export[i]?.can_buyer_keep_item === false ? "No" : "Seller Keep") : "",
                        return_type: j === 0 ? all_return_orders_for_export[i]?.return_type : "",
                        return_reason_text: j === 0 ? all_return_orders_for_export[i]?.return_reason_text : "",
                        refund_amount: j === 0 ? all_return_orders_for_export[i]?.refund_amount?.refund_total : "",
                        return_status: j === 0 ? all_return_orders_for_export[i]?.return_status : "",
                        return_line_items_seller_sku: "'" + all_return_orders_for_export[i]?.return_line_items[j]?.seller_sku,
                        return_line_items_return_line_item_id: "'" + all_return_orders_for_export[i]?.return_line_items[j]?.return_line_item_id,
                        return_line_items_order_line_item_id: "'" + all_return_orders_for_export[i]?.return_line_items[j]?.order_line_item_id,
                        return_line_items_product_image: all_return_orders_for_export[i]?.return_line_items[j]?.product_image?.url,
                        return_line_items_product_name: all_return_orders_for_export[i]?.return_line_items[j]?.product_name,
                        return_line_items_sku_id: "'" + all_return_orders_for_export[i]?.return_line_items[j]?.sku_id,
                        return_line_items_sku_name: all_return_orders_for_export[i]?.return_line_items[j]?.sku_name,
                        return_line_items_refund_amount: all_return_orders_for_export[i]?.return_line_items[j]?.refund_amount?.refund_total,
                        return_tracking_number: j === 0 ? all_return_orders_for_export[i]?.return_tracking_number : "",
                        role: j === 0 ? all_return_orders_for_export[i]?.role : "",
                        created_at: j === 0 ? formatterCreateAt(all_return_orders_for_export[i]?.create_time) : "",
                        updated_at: j === 0 ? formatterCreateAt(all_return_orders_for_export[i]?.update_time) : "",
                        shop: j === 0 ? (list_shop?.find((v2, i2) => v2._id === all_return_orders_for_export[i]?.shopId) ? list_shop.find((v2, i2) => v2._id === all_return_orders_for_export[i]?.shopId).name + " - " + list_shop.find((v2, i2) => v2._id === all_return_orders_for_export[i]?.shopId).note : "Deleted Shop") : "",
                        created_by: j === 0 ? staffs?.find((v2, i2) => v2?.value === all_return_orders_for_export[i]?.created_by)?.label : "",
                    }
                    export_return_orders_data.push(export_return_orders_data_tmp);
                }
                // export_return_orders_data.push({});
            }
            setExportReturnOrdersData(export_return_orders_data);
            setInitiateDownload(true);
        }
    }, [all_return_orders_for_export, formatterCreateAt]); // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setInitiateDownload(false);
        if (initiateDownload) {
            btnRef.current?.click();
        }
    }, [initiateDownload]);

    const onClicExportReturnOrders = () => {
        exportReturnOrders({ page, sizeperpage: sizePerPage, search: searchText, filter });
    }

    const onChangeShop = (e) => {
        var shops_tmp = e.map((v, i) => {
            return v.value
        });
        setFilter((prev) => ({
            ...prev,
            shops: shops_tmp || [],
        }));
        setShops(shops_tmp);
    }

    const handleCheckRecord = async (return_id, shopId) => {
        await getReturnRecordsById({ return_id, shopId }).then(async (r) => setRecords(r))
    };

    const columns = [
        {
            dataField: "_id",
            text: "",
            sort: true,
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        // {
        //     dataField: '-',
        //     text: t("Actions"),
        //     formatter: (cell, row, rowIndex, formatExtraData) => {
        //         row?.return_status === "RETURN_OR_REFUND_REQUEST_PENDING" && <>
        //             <button onClick={() => { }} className="btn btn-icon btn-bg-light btn-active-color-success btn-sm" data-tooltip-id="my-tooltip" data-tooltip-content={t("Approve Return")}>
        //                 <i className="ki-outline ki-check-square fs-2"></i>
        //             </button>
        //             <button onClick={() => { }} className="btn btn-icon btn-bg-light btn-active-color-warning btn-sm" data-tooltip-id="my-tooltip" data-tooltip-content={t("Reject Return")}>
        //                 <i className="ki-outline ki-cross-circle fs-2"></i>
        //             </button>
        //         </>
        //     }
        // },
        {
            dataField: "return_id",
            text: t("Return ID"),
            sort: true,
            formatter: (cell, row, rowIndex, formatExtraData) => <>
                <div className="mb-3">{cell}</div>
                <div className="text-small text-danger mb-2">Order ID: {row?.apiOrderId}</div>
                {row?.can_buyer_keep_item === false ? "" : <div className="text-small text-info mb-2">Keep Item: {row?.can_buyer_keep_item === false ? "No" : "Seller Keep"}</div>}
                <div className="btn btn-sm btn-light" onClick={() => handleCheckRecord(cell, row?.shopId)} data-tooltip-id="my-tooltip" data-tooltip-content={t("View Record")}>{row.return_type} <i className="ki-outline ki-eye fs-2"></i></div>
            </>
        },

        {
            dataField: 'shopId',
            text: t("Shop ID"),
            sort: true,
            headerClasses: 'd-none',
            classes: 'd-none',
            formatter: (cell, row) => <>
                {list_shop?.find((v, i) => v._id === cell) ? list_shop.find((v, i) => v._id === cell).name + " - " + list_shop.find((v, i) => v._id === cell).note : "Deleted Shop"}
            </>,
        },
        {
            dataField: "return_reason_text",
            text: t("Reason Text"),
            sort: true,
            formatter: (cell, row, rowIndex, formatExtraData) => <>
                <div className="mb-3" data-tooltip-id="my-tooltip" data-tooltip-content={row.return_reason}>{cell}</div>
            </>
        },
        {
            dataField: "refund_amount",
            text: t("Refund Amount"),
            sort: true,
            formatter: (cell, row) => cell?.refund_total || 0,
        },
        {
            dataField: "return_status",
            text: t("Return Status"),
            sort: true,
            formatter: (cell, row) => <>
                {
                    cell === "RETURN_OR_REFUND_REQUEST_PENDING" ?
                        <span className="badge badge-light-warning badge-sm">PENDING</span> :
                        cell === "REFUND_OR_RETURN_REQUEST_REJECT" ?
                            <span className="badge badge-light-danger badge-sm">REJECT</span> :
                            cell === "AWAITING_BUYER_SHIP" ?
                                <span className="badge badge-light-warning badge-sm">WAIT BUYER SHIP</span> :
                                cell === "BUYER_SHIPPED_ITEM" ?
                                    <span className="badge badge-light-primary badge-sm">BUYER SHIPED</span> :
                                    cell === "REJECT_RECEIVE_PACKAGE" ?
                                        <span className="badge badge-light-danger badge-sm">REJECT RECEIVE PACKAGE</span> :
                                        cell === "RETURN_OR_REFUND_REQUEST_SUCCESS" ?
                                            <span className="badge badge-light-info badge-sm">SUCCESS</span> :
                                            cell === "RETURN_OR_REFUND_REQUEST_CANCEL" ?
                                                <span className="badge badge-light-danger badge-sm">CANCEL</span> :
                                                cell === "RETURN_OR_REFUND_REQUEST_COMPLETE" ?
                                                    <span className="badge badge-light-success badge-sm">COMPLETE</span> :
                                                    cell === "AWAITING_BUYER_RESPONSE" ?
                                                        <span className="badge badge-light-warning badge-sm">WAIT BUYER RESPONSE</span> :
                                                        cell === "REPLACEMENT_REQUEST_COMPLETE" ? <span className="badge badge-light-success badge-sm">COMPLETE</span> :
                                                            "UNKNOWN"
                }
            </>
        },
        {
            dataField: "return_line_items",
            text: t("Items"),
            sort: true,
            formatter: (cell, row) => <>
                {/* <div className="d-flex">
                    {cell?.map((v, i) => <img src={v?.product_image?.url} key={i} alt="" className="thumnail" width={100} />)}
                </div>
                 */}
                <Fragment>
                    <div className="card">
                        <div className="card-header collapsible cursor-pointer rotate mt-2" data-bs-toggle="collapse" data-bs-target="#kt_docs_card_collapsible" aria-expanded={openIndex === row?._id} aria-controls={`collapse-${row?._id}`}>
                            <h3 className="card-title w-90 d-flex flex-wrap">
                                {cell?.length} {t("Items")}
                                <span className="d-flex flex-wrap w-100">
                                    {
                                        cell?.map((v, i) => {
                                            return (
                                                <Fragment key={i}>
                                                    <div className="symbol symbol-50px me-2 mt-4 " style={{ verticalAlign: "top" }}>
                                                        {
                                                            v?.product_image?.url ?
                                                                <Link to={v?.product_image?.url} target="_blank">
                                                                    <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: v?.product_image?.url }, largeImage: { src: v?.product_image?.url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                </Link>
                                                                :
                                                                <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                        }
                                                    </div>
                                                </Fragment>
                                            )
                                        })
                                    }
                                </span>
                            </h3>
                            <div className={cx("card-toolbar", { "rotate-180": openIndex === row?._id })} onClick={() => handleToggle(row?._id)}>
                                <i className="ki-duotone ki-down fs-1"></i>
                            </div>
                        </div>
                        <div id={`collapse-${row?._id}`} className={cx("collapse mt-2", { "show": openIndex === row?._id })}>
                            <div className="card-body">
                                {
                                    cell?.map((v, i) => {
                                        return (
                                            <Fragment key={i}>
                                                <div className="mb-3" style={{ minHeight: "85px" }}>
                                                    <div className="symbol symbol-50px me-2 mt-4" style={{ verticalAlign: "top" }}>
                                                        {
                                                            v?.product_image?.url ?
                                                                <Link to={v?.product_image?.url} target="_blank">
                                                                    <ReactImageMagnify {...{ smallImage: { alt: "", width: 50, height: 50, src: v?.product_image?.url }, largeImage: { src: v?.product_image?.url, width: 600, height: 600 }, enlargedImageContainerDimensions: { width: '600%', height: '600%' }, enlargedImageContainerStyle: { "zIndex": 99 } }} />

                                                                </Link>
                                                                :
                                                                <img src={require("components/assets/media/misc/image.png")} alt="" />
                                                        }
                                                    </div>
                                                    <div className="d-inline-block">
                                                        <span className="text-gray-900 fw-bold text-hover-primary fs-6 me-5">{subStringText(v?.product_name)}</span><button className="btn btn-link text-hover-primary" data-tooltip-id="my-tooltip"
                                                            data-tooltip-content={"Copy"}
                                                            onClick={() => navigator.clipboard.writeText(v?.product_name)}
                                                        >
                                                            <i className="ki-duotone ki-copy">
                                                            </i>
                                                        </button>
                                                        <span className="d-block text-gray-600 fw-bold text-hover-info fs-6">{v?.sku_name}</span>
                                                        <div className="">
                                                            {v?.seller_sku !== "" ? `Seller SKU: ${v?.seller_sku}` : ""}
                                                        </div>
                                                    </div>
                                                </div>
                                                {i + 1 !== row?.return_line_items.length ? <hr /> : ""}
                                            </Fragment>
                                        );
                                    })
                                }
                            </div>
                        </div>
                    </div>
                </Fragment>
            </>,
        },
        {
            dataField: "return_tracking_number",
            text: t("Return Tracking Number"),
            sort: true,
        },
        {
            dataField: "role",
            text: t("Role"),
            sort: true,
        },
        {
            dataField: "create_time",
            text: t("Created At"),
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "update_time",
            text: t("Updated At"),
            sort: true,
            formatter: (cell, row) => formatterCreateAt(cell),
        },
        {
            dataField: "shops",
            text: t("Shop"),
            sort: true,
            formatter: (cell, row) => <>
                <div>{cell?.name}</div>
                <div>{cell?.note} - {cell?.region}</div>
            </>,
        },
        {
            dataField: "created_by",
            text: t("Member"),
            sort: true,
            formatter: (cell, row) => staffs?.find((v, i) => v?.value === cell)?.label,
        }
    ];

    const handleTableChange = (type, { page, sizePerPage, searchText }) => {
        if (type === "search") {
            setPage(1);
            setSizePerPage(50);
            setSearchText(searchText);
        } else {
            setPage(page || 1);
            setSizePerPage(sizePerPage);
        }
    };
    const handleEventDate = (start, end) => {
        setPage(1);
        setSizePerPage(50);

        let date_start = new Date(start);
        date_start.setHours(0, 0, 0, 0);

        let date_end = new Date(end);
        date_end.setHours(23, 59, 59, 999);
        setFilter((prev) => ({
            ...prev,
            dateStart: date_start.getTime(),
            dateEnd: date_end.getTime(),
        }));
    };

    const groupButton = () => {
        return (
            <>
                <div className="mb-5 d-flex flex-md-row flex-column justify-content-between">
                    <div className="d-flex gap-2 mb-2">
                        <SelectBox
                            options={staffs}
                            name="filter_staff"
                            value={filter.staff || ""}
                            onChange={(data) => {
                                setFilter((prev) => ({
                                    ...prev,
                                    staff: data.value || "",
                                }));
                                setPage(1);
                            }}
                            placeholder={t("Select a staff ... ")}
                        />
                        <SelectBox
                            options={listStatus}
                            name="filter_status"
                            value={filter.status || ""}
                            onChange={(data) => {
                                setFilter((prev) => ({
                                    ...prev,
                                    status: data.value || "",
                                }));
                                setPage(1);
                            }}
                            placeholder={t("Select a status ... ")}
                        />
                        <SelectBox
                            options={listReturnType}
                            name="filter_return_type"
                            value={filter.return_type || ""}
                            onChange={(data) => {
                                setFilter((prev) => ({
                                    ...prev,
                                    return_type: data.value || "",
                                }));
                                setPage(1);
                            }}
                            placeholder={t("Select a return type ... ")}
                        />
                        <Select
                            isClearable
                            isMulti
                            name="shop"
                            options={listshop}
                            className="basic-multi-select al-custom-select-search-variants mt-0 me-2 mb-0 al-filter-table"
                            classNamePrefix="select"
                            value={listshop.filter(({ value }) => shops.includes(value))}
                            onChange={(e) => { onChangeShop(e) }}
                            placeholder={t("Select a shop ... ")}
                        />
                        <Select
                            name="dateType"
                            options={ListDateType}
                            className="al-select"
                            classNamePrefix="select"
                            value={ListDateType.filter(({ value }) => value === dateType)}
                            onChange={(e) => {
                                setDateType(e?.value || "");
                            }}
                            placeholder="Select a date ... "
                        />
                        {dateType === "custom" && filter?.dateStart && filter?.dateEnd ? (
                            <DateRangePicker
                                onCallback={handleEventDate}
                                initialSettings={{
                                    startDate: formatterCreateAt(filter.dateStart, "dmy"),
                                    endDate: formatterCreateAt(filter.dateEnd, "dmy"),
                                    showDropdowns: true,
                                    locale: { format: "DD/MM/YYYY" },
                                }}
                            >
                                <input type="text" className="form-control al-form-control-daterangepicker mr-1" />
                            </DateRangePicker>
                        ) : (
                            ""
                        )}
                        <button type="button" onClick={onClicExportReturnOrders} className="btn btn-success btn-sm me-2 mb-0">
                            <i className="fa fa-file-excel-o fs-2"></i> Export
                        </button>
                        <CSVLink filename={"return_orders_" + formatterCreateAt((new Date()).getTime(), "dmy", "Asia/Ho_Chi_Minh") + ".csv"} data={export_return_orders_data}>
                            <span ref={btnRef} />
                        </CSVLink>
                    </div>
                </div>
                <div className="mb-5 d-flex flex-md-row flex-column justify-content-start w-100 gap-2">
                    <span>{t("Total revenue:")} <span className="text-danger"><FormatterMoney money={total_revenue} /></span></span> | 
                    <span>{t("Total order refund:")} <span className="text-danger">{totalsize}</span></span>
                </div>
            </>
        );
    };

    return (
        <div className="card min-w-full">
            <Loading isLoading={isLoading} />
            <div className="card-body">
                <div className="al-variants-table al-max-height-table-cus">
                    <ReactTable
                        key={forceRender}
                        keyField="orders_return"
                        columns={columns}
                        data={list || []}
                        groupButton={groupButton}
                        handleTableChange={handleTableChange}
                        page={page}
                        sizePerPage={sizePerPage}
                        totalSize={totalSize}
                        alClassName="table-layout-inherit"
                        sizePerPageList={sizePerPageList}
                    />
                </div>
                <ModalRecord records={records} />
            </div>
        </div>
    );
};

const mapStateToProps = ({ returnOrders }) => ({ returnOrders });
const mapDispatchToProps = {
    getReturnOrders,
    formatterCreateAt,
    getStaffs,
    subStringText,
    getReturnRecordsById,
    exportReturnOrders,
};

export default connect(mapStateToProps, mapDispatchToProps)(Returns);
